import React from "react";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import { Dialog, DialogTitle } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import FileManager from "./MateDriveFileManager/FileManager";
import Close from '@material-ui/icons/Close';
import "./styles.css";

// MateDrive Dialog Model Design
export default function MateDrive(props) {

  //close model
  function handleClose() {
    props.setOpen(false);
  }

  return (
    <Dialog
      id="matedrive-dialog"
      data-test="autom-add-new"
      open={true}
      onClose={handleClose}
      PaperProps={{
        id: "matedrive-dialog"
      }}

    >
      <DialogTitle id="alert-dialog-title">
        <div id="about-title">
          Data Store
          <Button data-test="cancelautom-button" onClick={handleClose}>
            <Close />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <FileManager flowId={props?.flowId} />
      </DialogContent>
      <DialogActions
    style={{
      justifyContent: "flex-end",
      padding: "8px 24px 16px 24px",
    }}
    />
    </Dialog>
  );
}
